module.exports = __webpack_public_path__ + "img/grasshopper.be5030ca.webp";